<template>
  <p-vue-dropdown
    :options="entrancesOptions"
    val
    v-model="entrance"
    class="dropdown"
  >
    <template #value="{ value }">
      <div class="inner p-d-flex p-jc-between">
        <span>{{ value }}</span>
        <span class="icon">
          <i-icon name="arrow" />
        </span>
      </div>
    </template>
  </p-vue-dropdown>
  <div class="sms-to">
    <span>{{ __("Choose") }}: </span>
    <div class="sms-to-checkbox">
      <p-vue-checkbox v-model="renters" :binary="true" />
      <span>{{ __("Renters") }}</span>
    </div>
    <div class="sms-to-checkbox">
      <p-vue-checkbox v-model="owners" :binary="true" />
      <span>{{ __("Owner") }}</span>
    </div>
  </div>
  <i-form-error :data="errors.sendTo" class="p-mb-2" />
  <p-vue-textarea
    :autoResize="true"
    rows="4"
    class="p-inputtext--alt"
    v-model="message"
  />
  <i-form-error :data="errors.message" />
  <div class="p-d-flex p-jc-end p-mt-2">
    <p-vue-button
      class="p-button p-button-success p-button-rounded p-jc-center"
      @click="sendSMS($event)"
    >
      {{ __("Send a message") }}
    </p-vue-button>
  </div>
  <p-vue-confirm-popup></p-vue-confirm-popup>
</template>

<script>
import { dateFormat } from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";
import { errorReceived } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n/";
export default {
  props: {
    BID: {
      type: Number,
    },
    close: Function,
  },
  data() {
    return {
      dateFormat,
      entrancesOptions: [],
      entrance: "",
      owners: false,
      renters: false,
      message: null,
      errors: { sendTo: null, message: null },
    };
  },
  mounted() {
    this.GetEntrancesForBuilding();
  },
  methods: {
    GetEntrancesForBuilding() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("BID", this.BID, apiPType.Int)];
      callProc("webListEnteranceForBuilding", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.$store.dispatch("doLoading", false);
          this.entrancesOptions.push("כל הכניסות");
          result.Table.map((row) => {
            if (row.Entrance.length < 1) this.entrancesOptions.push("ראשית");
            else this.entrancesOptions.push(row.Entrance);
          });
          // console.log(this.entrancesOptions);
          this.entrance = this.entrancesOptions[0];
        })
        .catch(() => {
          errorReceived("webListEnteranceForBuilding");
        });
    },
    sendSMS(event) {
      if (!this.renters && !this.owners)
        this.errors.sendTo = 'Select "Owner", "Renters", or both';
      else
        this.$confirm.require({
          target: event.currentTarget,
          message: __("Are you sure?"),
          icon: "pi pi-exclamation-triangle",
          accept: () => {
            this.appSendMassSMS();
          },
          // reject: () => {
          //   //callback to execute when user rejects the action
          //   console.log("reject");
          // },
        });
    },
    appSendMassSMS() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("BID", this.BID, apiPType.Int),
        apiParam("Owners", this.owners, apiPType.Bit),
        apiParam("Renters", this.renters, apiPType.Bit),
        apiParam(
          "entrance",
          this.entrance == "כל הכניסות" ? "-1" : this.entrance,
          apiPType.VarChar
        ),
        apiParam("smsText", this.message, apiPType.VarChar),
        apiParam("userID", this.userNum, apiPType.Int),
      ];
      callProc("appSendMassSMS", procParams)
        .then(() => {
          // result = JSON.parse(result);
          // console.log(result);
          this.close();
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("appSendMassSMS");
        });
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
};
</script>

<style scoped>
.p-dropdown {
  width: 100%;
}

:deep(.svg) {
  color: var(--color-success);
  width: 18px;
  height: 18px;
}

.sms-to {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 15px 0;
}

.sms-to-checkbox {
  display: flex;
  align-items: center;
  gap: 7px;
}

.p-inputtextarea {
  width: 100%;
}
</style>
